module.exports = __webpack_public_path__ + "media/133.7529b025.wav";